import { createSlice } from "@reduxjs/toolkit";
import {
  getTrades,
  getTradesFiltered,
  getTradesPage,
  getTradesOfDateFiltered,
  getTradesStats,
  getTradesStatsFiltered,
  getUserTags,
} from "./thunks";
import { logout, expiredLogout, deleteUser } from "../auth/thunks";
import {
  addFulfilledCases,
  setField,
  setFieldFromPayloadKey,
} from "../utils/asyncHandlers";

const initialState = {
  trades: [],
  stats: {},
  tradesOfDay: [],
  tags: [],
};

const tradesSlice = createSlice({
  name: "trades",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addFulfilledCases(
      builder,
      [getTrades, getTradesFiltered, getTradesPage],
      setField("trades")
    );
    addFulfilledCases(
      builder,
      [getTradesStats, getTradesStatsFiltered],
      setField("stats")
    );
    builder
      .addCase(getTradesOfDateFiltered.pending, (state) => {
        state.tradesOfDay = null;
      })
      .addCase(getTradesOfDateFiltered.fulfilled, setField("tradesOfDay"))
      .addCase(getUserTags.fulfilled, setFieldFromPayloadKey("tags", "tags", []))
      .addCase(deleteUser.fulfilled, (state) => {
        state.trades = null;
        state.tradesOfDay = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.trades = null;
        state.stats = null;
        state.tradesOfDay = null;
      })
      .addCase(expiredLogout.fulfilled, (state) => {
        state.trades = null;
        state.stats = null;
        state.tradesOfDay = null;
      });
  },
});

export default tradesSlice.reducer;
